﻿namespace WebPortal.Dialog.Modal.Session {

    /**
     * ************************************************************************************
     *                              Session Join Modal
     *   ************************************************************************************
     */
    export class Join {

        private newTab: boolean = false;

        constructor(newTab: boolean) {
            this.newTab = newTab;
            this.init();
        }

        private init(): void {

            // navigationsmenü
            $("#navigation_lbt_join_session").off().on("click", () => {
                this.show();
                return false;
            });
        }

        public show(): void {
            this.prepareModal();
            $("#modal_join_session").modal({ backdrop: "static", keyboard: true });
        }

        private prepareModal(): boolean {

            // modal
            $("#modal_join_session").on("shown.bs.modal", () => {
                $("#tf_join_session").focus();
            });

            // button
            $("#bt_join_session_connect").on("click", () => {
                this.openJoinPage(this.newTab);
            }).keyup((e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    this.openJoinPage(this.newTab);
                }
                return false;
            });

            // textfeld
            $("#tf_join_session").on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (this.sessionLinkCorrect($(e.currentTarget).val())) {
                    $("#modal_join_session_body").children(".form-group").removeClass("has-error").addClass("has-success");
                    $("#join_session_symbol").removeClass("icon--flip-vertical").addClass("icon-086-thumb-up");
                    if (ev.keyCode === 13) {
                        this.openJoinPage(this.newTab);
                    }
                } else {
                    if ($(ev.currentTarget).val().length > 0) {
                        $("#modal_join_session_body").children(".form-group").removeClass("has-success").addClass("has-error");
                        $("#join_session_symbol").addClass("icon--flip-vertical").addClass("icon-086-thumb-up");
                    } else {
                        $("#modal_join_session_body").children(".form-group").removeClass("has-error");
                        $("#join_session_symbol").removeClass("icon--flip-vertical");
                    }
                }
                return false;
            });

            return false;
        }

        private sessionLinkCorrect(sessionLink: any): boolean {
            if (sessionLink && WebPortal.Misc.regJoinLinkCheck(sessionLink)) {
                return true;
            }
            return false;
        };

        private resetContent(): void {
            $("#tf_join_session").val("");
            $("#modal_join_session_body").children(".form-group").removeClass("has-success").removeClass("has-error");
            $("#join_session_symbol").removeClass("glyphicon-ok");
            $(".alert").remove();
        };

        private openJoinPage(newTab: boolean): void {
            let sessionLink: string = $("#tf_join_session").val();
            if (this.sessionLinkCorrect(sessionLink)) {
                const requestParam: string = $("#hdf_se_request_param").val();
                if (!!requestParam) {
                    if (newTab) {
                        WebPortal.openWindow(sessionLink);
                    } else {
                        const id: string = Misc.getUrlParameter('id', sessionLink);
                        const token: string = Misc.getUrlParameter('token', sessionLink);
                        if (id && token) {
                            const gatewayUrl: string = $("#hdf_se_gateway_param").val();
                            const currentSettings: any = JSON.parse($("#hdf_settings").val());
                            currentSettings.id = id;
                            currentSettings.token = token;
                            currentSettings.r5_joinrequest = requestParam;
                            rdpJoin.connect(gatewayUrl, currentSettings);
                        }
                    }
                    $("#modal_join_session").modal("hide");
                    this.resetContent();
                } else {
                    $(".alert").remove();
                    $("#modal_join_session_body")
                        .append($("<div>")
                            .attr({
                                "class": "alert alert-danger",
                            }).text("Parameter Error for action. Please contact CoC REMAS +41 800 724 500")
                        );
                }
            } else {
                $(".alert").remove();
                $("#modal_join_session_body")
                    .append($("<div>")
                        .attr({
                            "class": "alert alert-danger",
                        }).text("Invalid Session Link")
                    );
            }
        }
    }
}